<template>
  <!-- eslint-disable  -->
  <!--HEADER START-->
  <div id="header-logo-buttons" ref="headerRef" class="shadow-sm fixed-top d-inline-flex"
    :class="getCurrentProductTypeClass" role="banner" style="z-index:1099" :key="refreshKey">
    <div class="w-100 header-logo-wrapper d-inline-block">
      <!--Skip to main content component-->
      <skip-to-content></skip-to-content>
      <div class="pl-0 pr-0 h-100 d-inline float-left">
        <div id="qsLogo" class="h-100 pl-3 float-left">
          <img height="66" width="200" :src="require(`../../assets/clients/${agencyLogo}-wht.svg`)" id="qrp-logo"
            alt="Rating Platform Logo" v-if="agencyLogo" />
          <img height="66" width="200" src="../../assets/qrp-abbreviated-wht.svg" alt="QuinStreet Rating Platform"
            v-else />
        </div>
        <div class="logo-sep mx-3 float-left"></div>
        <div id="insuranceType" class="h-100 float-left">
          <span class="fas fa-icon-size align-middle" :class="faIcon"></span>
        </div>
        <div class="product-title-parent float-left" :class="productclass">{{ productName }}<span
            v-if="flowType !== 'cabundle' && flowType !== 'rabundle'"> Insurance</span><span
            v-if="flowType === 'cabundle' || flowType === 'rabundle'"> Bundle</span></div>
        <div v-show="rc2ProgTrue()" class="rc2-car-logo float-left">
          <img height="30" width="120" :src="$store.getters.getRc2LogoURLWhite" alt="Carrier logo" />
        </div>
      </div>
      <div class="menu-links d-inline float-right h-100 px-0 my-auto bg-white">
        <div class="d-flex my-auto mx-0 float-right icon-row h-100">
          <a href="JavaScript:void(0);" tabindex="0" id="export-toggle" v-b-tooltip.hover
            class="my-auto navItem d-inline-block text-center border-right-custom btn-fade initialExport"
            :class="{ clickableExport: isExportable }" @click.prevent="isExportable ? popExportModal() : null"
            v-if="$route.name !== 'search' && isEpicClient">
            <span class="fas fa-file-export d-block mx-auto uniform-icon-size"
              title="Export Customer Information"></span>
            <div class="btn-label">Export Quote</div>
          </a>
          <b-tooltip v-if="isEpicClient" target="export-toggle" triggers="focus hover" placement="bottom">
            Name Insured information must be completed.
          </b-tooltip>
          <a href="JavaScript:void(0);" tabindex="0" id="add-product-toggle" v-b-tooltip.hover
            class="my-auto navItem d-inline-block text-center border-right-custom btn-fade initialAddProduct"
            :class="{ clickableAddProduct: isAddProductEnable }" @click.prevent="popAddProductModal()"
            v-if="isShowAddProduct">
            <span class="fas fa-file-circle-plus d-block mx-auto uniform-icon-size" title="Add Product"></span>
            <div class="btn-label">Add Product</div>
          </a>
          <a href="JavaScript:void(0);" tabindex="0" id="do-not-call" v-b-tooltip.hover
            class="my-auto navItem d-inline-block text-center border-right-custom btn-fade initialForceBind"
            :class="{ clickableForceBind: namedInsuredStatus() }" @click.prevent="popDoNotCallModal()"
            v-if="$route.name !== 'search' && quoteStatus !== 'Bound'">
            <span class="fas fa-solid fa-phone-slash d-block mx-auto uniform-icon-size" title="Donotcall"></span>
            <div class="btn-label">Do Not Call</div>
          </a>
          <b-tooltip target="do-not-call" triggers="focus hover" placement="bottom">
            Do not Call.
          </b-tooltip>
          <a href="JavaScript:void(0);" tabindex="0" id="force-bind-toggle" v-b-tooltip.hover
            class="my-auto navItem d-inline-block text-center border-right-custom btn-fade initialForceBind"
            :class="{ clickableForceBind: forceBindEnable() }" @click.prevent="popForceBindModal()"
            v-if="$route.name !== 'search' && enableForcebindOnQuote !== 'Bound'">
            <span class="fas fa-file-invoice-dollar d-block mx-auto uniform-icon-size" title="Force Bind"></span>
            <div class="btn-label">Force Bind</div>
          </a>
          <b-tooltip target="force-bind-toggle" triggers="focus hover" placement="bottom">
            Name Insured information must be completed.
          </b-tooltip>
          <a href="JavaScript:void(0);"
            :class="{ 'disabled': $route.name === 'search', 'cursorPointer': $route.name !== 'search' }"
            class="my-auto cursorDefault navItem d-inline-block text-center btn-fade" @click.prevent="searchResult"
            tabindex="0">
            <span class="fas fa-search d-block mx-auto uniform-icon-size" title="Search Results"></span>
            <div class="btn-label">Search Results</div>
          </a>
          <a href="JavaScript:void(0);"
            class="my-auto border-left-custom cursorPointer navItem d-inline-block text-center btn-fade"
            @click.prevent="saveBeforNavigate" tabindex="0">
            <span class="fas fa-tachometer-alt d-block mx-auto uniform-icon-size" title="Dashboard"></span>
            <div class="btn-label">Dashboard</div>
          </a>
          <a href="JavaScript:void(0);"
            class="border-left-custom cursorPointer navItem d-inline-block text-center btn-fade"
            @click.prevent="toUserProfile()" tabindex="0">
            <span class="fas fa-user-circle d-block mx-auto uniform-icon-size" title="Dashboard"></span>
            <div class="btn-label">{{ getUserName() }}</div>
          </a>
          <a href="JavaScript:void(0);"
            class=" my-auto navItem d-inline-block text-center border-left-custom cursorPointer btn-fade"
            @click.prevent="onLogout" tabindex="0">
            <span class="fas fa-sign-out-alt d-block mx-auto uniform-icon-size" title="Logout"></span>
            <div class="btn-label">Logout</div>
          </a>
        </div>
      </div>
    </div>
    <modal name="add-product-modal" width="55%" height="auto" :scrollable="true" focusTrap:true>
      <Trap>
        <div class="breakdown-modal-top pt-3 pb-2 pl-3 pr-2 text-white dark-bg">
          <h3 class="breakdown-modal-header">Add Product to {{ productName }} Quote</h3>
          <a href="JavaScript:void(0);" @click.prevent="$modal.hide('add-product-modal')"
            class="cursorBox fa-stack uniform-icon-breakdown">
            <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
            <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
          </a>
        </div>        
        <add-product-modal :productName="productName"></add-product-modal>
      </Trap>
    </modal>
    <modal name="DoNotCall_ConfirmationModal" height="auto" :scrollable="true" focusTrap:true>
      <Trap>
        <div class="breakdown-modal-top pt-3 pb-2 pl-3 pr-2 text-white" :class="getModalFormStyle()">
          <h3 class="breakdown-modal-header">Mark as Do Not Call</h3>
          <!-- <a href="JavaScript:void(0);" @click.prevent="routeToSearch()"
            class="cursorBox fa-stack uniform-icon-breakdown">
            <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
            <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
          </a> -->
        </div>
        <!-- CONFIRM & CONSENT NOTICE -->
        <div class="mb-4">
          <div class="d-block justify-content-center mx-auto my-3">
            <div class="alert  alert-success mx-3 my-0 py-2" role="alert">
              <div class="row no-gutters">
                <div class="d-inline-block pr-2 my-auto">
                  <img width="25px" height="25px" src="../../assets/check-circle-green.svg" alt="info">
                </div>
                <div class="col smaller-font-content d-inline-block my-auto">
                  <b>Success:</b> This lead has been marked as Do Not Call and will be removed from all future
                  remarketing communications for the associated customer.
                </div>
              </div>
            </div>
          </div>
          <!-- CONFIRM & CONSENT NOTICE -->
          <button type="submit" id="successDoNotCall" @click.prevent="successDoNotCall()"
            class="btn btn-primary d-block mx-auto">OK</button>
        </div>
      </Trap>
    </modal>
    <modal name="force-bind-modal" width="55%" height="auto" :scrollable="true" focusTrap:true @opened="forceBindModalOpen">
      <Trap>
        <div class="breakdown-modal-top pt-3 pb-2 pl-3 pr-2 text-white" :class="getModalFormStyle()">
          <h3 class="breakdown-modal-header">Force Bind {{ productNameForModal }} Insurance</h3>
          <a href="JavaScript:void(0);" @click.prevent="$modal.hide('force-bind-modal')"
            class="cursorBox fa-stack uniform-icon-breakdown">
            <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
            <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
          </a>
        </div>
        <p class="px-3 mt-2 smaller-font-content">Please enter binding information if this policy has been bound in a
          third party system. You may force bind for each policy individually by clicking Force Bind from each product's
          flow.</p>
        <div class="px-3" v-if="formErrors.general">
          <div class="alert alert-danger" role="alert">
            {{ formErrors.general }}
          </div>
        </div>
        <monoline-force-bind-modal :carriers="carriers" :namedInsuredStatus="namedInsuredStatus"
          :productName="productName"
          v-if="flowType !== 'bundle' && flowType !== 'cabundle' && flowType !== 'rabundle'"></monoline-force-bind-modal>
        <bundle-force-bind-modal :carriers="carriers" :autoCarriers="autoCarriers" :namedInsuredStatus="namedInsuredStatus"
          v-else></bundle-force-bind-modal>
      </Trap>
    </modal>
    <modal name="do-not-call" height="auto" :scrollable="true" focusTrap:true>
      <Trap>
        <div class="breakdown-modal-top pt-3 pb-2 pl-3 pr-2 text-white " :class="getModalFormStyle()">
          <h3 class="breakdown-modal-header">Mark as Do Not Call</h3>
          <a href="JavaScript:void(0);" @click.prevent="$modal.hide('do-not-call')"
            class="cursorBox fa-stack uniform-icon-breakdown">
            <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
            <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
          </a>
        </div>
        <div class="mb-4">
          <p class="px-3 mt-2 smaller-font-content">Please confirm that you would like to mark this lead as Do Not Call
            (i.e. To have the lead enter free marketing, to remove it from a call list, or to disqualify the lead).</p>
          <!-- CONFIRM & CONSENT NOTICE -->
          <div class="d-block justify-content-center mx-auto my-3 ">
            <div class="alert alert-warning mx-3 my-0 py-2" role="alert">
              <div class="row no-gutters">
                <div class="d-inline-block pr-2 my-auto">
                  <img width="25px" height="25px" src="../../assets/exclamation-circle-yellow-new.svg" alt="info">
                </div>
                <div class="col smaller-font-content d-inline-block my-auto">
                  <p class="mb-0">This action will remove all remarketing for the customer associated with:<br>
                    &nbsp;&nbsp; <b>Email:</b> {{ quoteDataemail }}<br>&nbsp;&nbsp; <b>Phone:</b> {{ quoteDataPhone }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- CONFIRM & CONSENT NOTICE -->
          <button type="submit" v-if="namedInsuredStatus()" id="Do_Not_Call_button"
            class="btn btn-outline-danger d-block mx-auto" @click.stop.prevent="DoNotCall()">Mark as Do Not
            Call</button>
        </div>
      </Trap>
    </modal>
    <modal name="export-modal" height="auto" :scrollable="true" focusTrap:true>
      <Trap>
        <div class="px-3 m-4 export-modal-container">
          <p>You can only export customer data once per quote. Please be sure to save the page before
            exporting.<br />Are you sure you want to export?</p>
          <br />
          <div class="buttons">
            <button type="button" id="export-cancel-button" class="btn btn-primary d-block mx-auto"
              v-on:click="$modal.hide('export-modal')">Cancel</button>
            <button type="button" v-if="namedInsuredStatus()" id="export-submit-button"
              class="btn btn-primary d-block mx-auto" v-on:click="submitExportQuote">Export</button>
          </div>
        </div>
      </Trap>
    </modal>
    <div v-if="exportSuccess" class="alert alert-success alert-dismissible fade show export-quote-success" role="alert">
      <div class="row">
        <div class="d-inline-block float-left align-self-center mx-2 text-center">
          <span class="fas fa-check-circle epic-alert-icon"></span>
        </div>
        <div class="col px-0 d-inline-block">
          <h4>Export Successful!</h4>
          <p>The customer data has been exported. This quote customer data cannot be exported again.</p>
        </div>
      </div>
    </div>
    <div v-if="exportFailure" class="alert alert-danger alert-dismissible fade show export-quote-failure" role="alert">
      <div class="row">
        <div class="d-inline-block float-left align-self-center mx-2 text-center">
          <span class="fas fa-exclamation-circle epic-alert-icon"></span>
        </div>
        <div class="col px-0 d-inline-block">
          <h4>Export Failure!</h4>
          <p>The customer data was not exported. Please try again. If the issue continues, then please contact your
            system administrator.</p>
        </div>
      </div>
    </div>
  </div>
  <!--HEADER END-->
</template>

<script>

/* eslint-disable */
import Trap from 'vue-focus-lock';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import fetchData from '../../services/fetchData';
import postData from '../../services/postData';
import EventBus from '../interview/shared/interview-event-bus';
import SkipToContent from './SkipToContent';
import MonolineForceBindModal from './MonolineForceBindModal';
import BundleForceBindModal from './BundleForceBindModal';
import AddProductModal from './AddProductModal';
import QRP from '../../../config/QRP.env';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
      productNameForModal: '',
      customer_email: 'q',
      customer_phone: 'q',
      flowType: '',
      agencyLogo: '',
      carriers: [],
      autoCarriers: [],
      selectedCarrier: '',
      refreshKey: 'hkey-1',
      showQuoteSummary: false,
      exportFailure: false,
      exportSuccess: false,
      isExportable: false,
      isEpicClient: false,
      forcebindcarrierselectref: '',
      currentProductType: '',
      formErrors: {
        general: '',
        carrier: '',
        policyNumber: '',
        finalPremium: '',
        effectiveDate: '',
        termLength: '',
      },
      productBranding: {
        home: {
          icon: 'fa-home',
        },
        auto: {
          icon: 'fa-car',
        },
        condo: {
          icon: 'fa-hotel',
        },
        renters: {
          icon: 'fa-building',
        },
        bundle: {
          icon: 'fa-home-auto-bundle',
        },
        cabundle: {
          icon: 'fa-condo-auto-bundle',
        },
        rabundle: {
          icon: 'fa-renter-auto-bundle',
        },
      },
    };
  },
  created() {
    this.quoteData();
    this.flowType = sessionStorage.getItem('flowType');
    if (this.$store.getters.getAgencyLogo) {
      this.agencyLogo = this.$store.getters.getAgencyLogo;
    }
    // this searches for the productType property amongst the route array elements to determine the current product type.
    for (let i = this.$route.matched.length - 1; i >= 0; i -= 1) {
      if (this.$route.matched[i].meta && this.$route.matched[i].meta.productType) {
        this.currentProductType = this.$route.matched[i].meta.productType;
        return;
      }
    }
  },
  mounted() {
    EventBus.$on('refresh-header', () => {
      this.refreshCount += 1;
      this.$nextTick(() => {
        this.refreshKey = `hkey-${Math.random()}`;
      });
    });
    this.$root.$on('export-enabled-header', (value) => {
      if (this.namedInsuredStatus()) {
        this.isExportable = value;
      } else {
        this.isExportable = false;
      };
    });
    this.$root.$on('epic-enabled-header', (value) => {
      this.isEpicClient = value;
    });
  },
  components: {
    vSelect,
    Trap,
    Datepicker,
    SkipToContent,
    MonolineForceBindModal,
    BundleForceBindModal,
    AddProductModal
  },
  computed: {
    isAddProductEnable() {
      if (this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') {
        return false;
      } else if (this.$store.state.buttonState.quoteSummaryData && this.$store.state.buttonState.quoteSummaryData.quote_status === 'Bound') {
        return false;
      }
      let productAccess = JSON.parse(sessionStorage.getItem('productAccess'));
      if ((productAccess && productAccess.includes(QRP.PRODUCTS.AUTO)) && ((productAccess && productAccess.includes(QRP.PRODUCTS.HOME)) || (productAccess && productAccess.includes(QRP.PRODUCTS.CONDO)) || (productAccess && productAccess.includes(QRP.PRODUCTS.RENTERS)))) {
      return this.namedInsuredStatus();
      }
      return false;
    },
    isShowAddProduct() {
      if (this.$route.name === 'search') {
        return false;
      }
      return true;
    },
    enableForcebindOnQuote() {
      if ((this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') && (sessionStorage.getItem('homebound') !== 'true' || sessionStorage.getItem('autobound') !== 'true')) {
        return 'showForcebindIcon';
      } else
        return this.$store.state.buttonState.quoteSummaryData ? this.$store.state.buttonState.quoteSummaryData.quote_status : '';
    },
    getCurrentProductTypeClass() {
      return this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle' ? this.currentProductType + ' bundleflow' : this.currentProductType;
    },
    quoteDataPhone() {
      return this.$store.state.buttonState.quoteSummaryData.quote_summary_sections[0] ? this.$store.state.buttonState.quoteSummaryData.quote_summary_sections[0].content[0].fields[3].field_value : '';
    },
    quoteDataemail() {
      return this.$store.state.buttonState.quoteSummaryData.quote_summary_sections[0] ? this.$store.state.buttonState.quoteSummaryData.quote_summary_sections[0].content[0].fields[2].field_value : '';
    },
    quoteStatus() {
      return this.$store.state.buttonState.quoteSummaryData ? this.$store.state.buttonState.quoteSummaryData.quote_status : '';
    },
    productclass() {
      return this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle' ? 'bundleflow' : this.currentProductType;
    },
    faIcon() {
      return this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle' ? this.productBranding[this.flowType].icon : this.productBranding[this.currentProductType].icon ? this.productBranding[this.currentProductType].icon : '';
    },
    /**
     * return product name based on product flow
     */
    productName() {
      if (this.flowType === 'bundle') {
        return 'Home + Auto';
      } else if (this.flowType === 'cabundle') {
        return 'Condo + Auto';
      } else if (this.flowType === 'rabundle') {
        return 'Renters + Auto';
      } else if (this.$route.path.includes('/home/')) {
        return 'Home';
      } else if (this.$route.path.includes('/condo/')) {
        return 'Condo';
      } else if (this.$route.path.includes('/renters/')) {
        return 'Renters';
      } else if (this.$route.path.includes('/auto/')) {
        return 'Auto';
      }
      return '';
    },
  },
  methods: {
    /**
    * get User name
    */
    quoteData() {
      return this.$store.state.buttonState.quoteSummaryData ? this.$store.state.buttonState.quoteSummaryData.quote_summary_sections : '';
    },
    getUserName() {
      return sessionStorage.getItem('userFirstName') + ' ' + sessionStorage.getItem('userLastName');
    },
    /**
    * redirect oto user profile page
    */
    toUserProfile() {
      const userId = sessionStorage.getItem('userId');
      this.$router.push({ path: `/dashboard/your-profile?userID=${userId}` });
    },
    testingExportBox(value) {
      if (value === 'success') {
        this.exportSuccess = true;
        setTimeout(() => {
          this.exportSuccess = false;
        }, 4000);
      } else {
        this.exportFailure = true;
        setTimeout(() => {
          this.exportFailure = false;
        }, 4000);
      }
    },
    getHomeCarrier() {
      return sessionStorage.getItem('selectedCarrierHome') ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')) : '';
    },
    getAutoCarrier() {
      return sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')) : '';
    },
    forceBindEnable() {
      return this.namedInsuredStatus();
    },
    /**
     * check named insured tab status to show/hide submit button
     */
    namedInsuredStatus() {
      const tabData = this.$store.state.buttonState.buttonsData || [];

      for (let tCnt = 0; tCnt <= tabData.length; tCnt += 1) {
        if (tabData[tCnt] && tabData[tCnt].name && tabData[tCnt].name.includes('NamedInsured')) {
          if (tabData[tCnt].status === 'ActiveComplete' || tabData[tCnt].status === 'InactiveComplete') {
            return true;
          }
        }
      }
      return false;
    },
    /**
     * return class name for different product
     */
    getModalFormStyle() {
      if (this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') {
        this.productNameForModal = '';//TODO
        return 'bg-primary-bundle';
      } else if (this.$route.path.includes('/home/')) {
        this.productNameForModal = ' - Home';
        return 'bg-primary-home';
      } else if (this.$route.path.includes('/condo/')) {
        this.productNameForModal = ' - Condo';
        return 'bg-primary-condo';
      } else if (this.$route.path.includes('/renters/')) {
        this.productNameForModal = ' - Renters';
        return 'bg-primary-renters';
      } else if (this.$route.path.includes('/auto/')) {
        this.productNameForModal = ' - Auto';
        return 'bg-header-auto';
      }
      return '';
    },
    /**
     * save form data before navigate to dashboard
     */
    saveBeforNavigate() {
      this.$store.dispatch('setUserNavFlag', true);
      this.$router.push('/dashboard');
    },
    /**
     * update quote summary status and check if form container is fixed
     */
    updateQuoteSummaryStatus() {
      this.$store.dispatch('quoteSummaryStatusToggle');
      // check if form container has fix top
      const formContainer = document.getElementById('form-container'); // TODO: Set once
      if (formContainer && formContainer.classList.contains('fixed-top') && this.$store.getters.getQuoteSummaryStatus) {
        formContainer.classList.add('quote-panel-scroll');
      } else if (!this.$store.getters.getQuoteSummaryStatus) {
        formContainer.classList.remove('quote-panel-scroll');
      }
    },
    /**
     * return true if rc2 started
     */
    rc2ProgTrue() {
      const currentRoute = this.$router.currentRoute;
      if ((this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') && (this.quoteStatus === 'Bound')) {
        return false;
      }
      if ((this.flowType === 'bundle' || this.flowType === 'cabundle' || this.flowType === 'rabundle') && (currentRoute.path.includes('checkout') || currentRoute.path.includes('confirmation') || currentRoute.path.includes('non-end-to-end'))) {
        return false;
      }
      if (currentRoute.fullPath.indexOf('search') !== -1) {
        return false;
      } else if (currentRoute.meta.rateCall > 1) {
        return true;
      }
      else if (currentRoute.meta.parentPath === 'rc2') {
        return true;
      }
      return false;
    },
    variationDisplay() {
      const variationDisplay = sessionStorage.getItem('variation');

      return (variationDisplay !== '1.0' ? `v${variationDisplay}` : false); // TODO: Use config values
    },
    onLogout() {
      this.$store.dispatch('setUserNavFlag', true);
      // this.$store.commit('clearSessionData');
      // this.$store.dispatch('agentLogout');
      this.$router.push('/Intermediate');
    },
    searchResult() {
      if (this.$route.name !== 'search') {
        this.$store.dispatch('setUserNavFlag', true);
        this.$store.dispatch('quoteSummaryStatusReset');
        this.$router.push('/search');
      }
    },
    saveExit() {
      if (this.$route.name !== 'search') {
        // submit form, clear search result history and redirect to empty search page.
      }
    },
    initializeForceBindModal() {
      this.clearErrors();
      //this.$refs.forcebindcarrierselectref.focus();
      const forceBindCarrierSelect = document.getElementById('force-bind-carrier-select');
      // forceBindCarrierSelect.focus();
      const forceBindSubmitButton = document.getElementById('force-bind-submit-button');

      forceBindSubmitButton.disabled = true;
    },
    customfocusHandler() {
      this.$validator.clean();
    },
    forceBindModalOpen() {
      this.initializeForceBindModal();
      let sessionID = this.$store.getters.getSessionID;
      if (this.productName === 'Home' || this.productName === 'Condo' || this.productName === 'Renters') {
        this.getCarriersData(sessionID, '');
      } else if (this.productName === 'Auto') {
        this.getCarriersData(sessionID, '');
      } else {
        let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId; 
        let HOQuoteId;       
        if (this.flowType === 'bundle') {
          HOQuoteId = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId;        
        } else if (this.flowType === 'cabundle') {
          HOQuoteId = JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId;
        } else if (this.flowType === 'rabundle') {          
          HOQuoteId = JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId;
        }
        this.getCarriersData(HOQuoteId, '');
        this.getCarriersData(AUQuoteId, 'auto');
      }
    },
    getCarriersData(sessionID, type) {
      const url = `autoquotes/${sessionID}/carriers`;
      this.carriers = [{
        'carrier_id': '',
        'carrier_name': 'Select one'
      }];
      fetchData.getCarriersData(url).then((response) => {
        console.log('response', response);
        const forceBindCarrierSelect = document.getElementById('force-bind-carrier-select');
        const forceBindSubmitButton = document.getElementById('force-bind-submit-button');
        const sortedArray = Object.entries(response.data.carrier_lookup).sort((a, b) => {
          const nameA = a[1][Object.keys(a[1])].carrier_name;
          const nameB = b[1][Object.keys(b[1])].carrier_name;

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });

        sortedArray.map(el => {
          let tempObj = {};
          if (el[0] !== 'Ezlynx') {
            tempObj = {
              'carrier_id': el[1][Object.keys(el[1])[0]].carrier_id,
              'carrier_name': el[1][Object.keys(el[1])[0]].carrier_name
            };
          } else {
            Object.entries(el[1]).forEach((el2) => {
              tempObj = {
                'carrier_id': el2[1].carrier_id,
                'carrier_name': el2[1].carrier_name
              };
            });
          }
          if (type === 'auto') {
            this.autoCarriers.push(tempObj);
          } else {
            this.carriers.push(tempObj);
          }
        });
        forceBindCarrierSelect.disabled = false;
        forceBindSubmitButton.disabled = false;
      }).catch((error) => {
        this.formErrors.general = error.message;
      });
    },
    clearDateErrors() {
      this.formErrors.effectiveDate = '';
    },
    clearErrors() {
      this.formErrors = {};
    },
    popAddProductModal() {
      if (this.isAddProductEnable) {
        this.$modal.show('add-product-modal');
      }
    },
    popForceBindModal() {
      if (this.namedInsuredStatus()) {
        this.$modal.show('force-bind-modal');
      }
    },
    popDoNotCallModal() {
      if (this.namedInsuredStatus()) {
        this.$modal.show('do-not-call');
      }
    },
    popExportModal() {
      if (this.namedInsuredStatus()) {
        this.$modal.show('export-modal');
      }
    },
    DoNotCall() {
      const doNotCallButton = document.getElementById('Do_Not_Call_button');
      doNotCallButton.disabled = true;
      const requestBody = {
        session_id: this.$store.getters.getSessionID,
      };
      const url = '/quotes/unsubscribePromoCalls';
      postData.submitForceBind(url, requestBody).then((response) => {
        if (response.status === 200 && response.statusText === 'OK') {
          this.$modal.hide('do-not-call');
          this.DoNotCallConfirmationModal();
          doNotCallButton.disabled = false;
        }
      }).catch((error) => {
        this.formErrors.general = error.response.data.Message;
      });
    },
    DoNotCallConfirmationModal() {
      this.$modal.show('DoNotCall_ConfirmationModal');
    },
    successDoNotCall() {
      this.$router.push({
        name: 'search',
        params: {
          forceBindData: 'make it truthy!'
        }
      });
    },


    submitExportQuote() {
      const requestParams = {
        url: '/quotes/epicexportclient',
        data: {
          sessionId: this.$store.getters.getSessionID,
        },
      };
      postData.exportQuoteEpic(requestParams).then((response) => {
        this.$modal.hide('export-modal');
        this.exportSuccess = true;

        setTimeout(() => {
          this.exportSuccess = false;
        }, 4000);

        console.log(response);
        this.isExportable = false;
      }).catch((error) => {
        this.exportFailure = true;

        setTimeout(() => {
          this.exportFailure = false;
        }, 4000);

        console.log(error);
      });
    }
  },
};
</script>
<style lang="scss">
.v-select .vs__actions .clear,
.v-select .dropdown-toggle::after {
  display: none !important;
}

.v-select .dropdown-toggle .clear {
  visibility: hidden !important;
}

.v-select .vs__actions .clear,
.v-select .dropdown-toggle .clear::after {
  display: none !important;
}

.v-select .vs__actions .clear span {
  display: none !important;
}

.v-select .dropdown-toggle .clear {
  visibility: hidden !important;
}

.hidden-field {
  display: none;
}

/**V-SELECT: STYLING OVERRIDES**/
.dropdown {
  display: inline-block;
}

.v-select .dropdown-toggle {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
}

.v-select.disabled .dropdown-toggle,
.v-select.disabled .dropdown-toggle input,
.v-select.disabled .dropdown-toggle .selected-tag {
  pointer-events: none !important;
  color: #333333 !important;
  cursor: not-allowed !important;
  background-color: #EEEEEE;
}

.form-control::placeholder {
  color: #999999 !important;
}

.v-select .vs__selected-options {
  position: relative;
  width: auto !important;
  height: 21px;
  min-width: 100px;
  padding: 0 10px;
  flex-basis: initial;
  flex-grow: initial;
  flex-wrap: initial;
  flex: 1 0 auto;
  -ms-flex: 1 0 auto;
}

/**Input**/
.v-select input[type=search],
.v-select input[type=search]:focus {
  height: auto;
  padding: 0;
  border: none;
}

.v-select.open input[type=search] {
  position: absolute;
  width: 100% !important;
}

/**Selected Value**/
.v-select .selected-tag {
  position: relative !important;
  margin: 4px 0 0;
  padding: 0;
}

/**Toggle Arrow Icon**/
.v-select .vs__actions {
  padding: 0 5px;
}

.v-select .open-indicator {
  width: 20px;
  background: none !important;
}

.v-select .open-indicator:before {
  margin: 0 auto;
}

.v-select.open .open-indicator:before {
  margin: 10px auto 0;
}

/**Dropdown Options**/
.dropdown-menu {
  width: auto !important;
  padding: 0 0 0.25rem !important;
  overflow-x: hidden;
  overflow-y: auto !important;
  font-size: 0.75rem;
  border-left: 1px solid #CCCCCC !important;
  border-right: 1px solid #CCCCCC !important;
  border-bottom: 1px solid #CCCCCC !important;
  border-top: none !important;
}

.dropdown-menu li>a {
  padding: 3px 20px 3px 10px !important;
}

.force-bind-modal .field-input-radio .btn-group-toggle:focus-within,
.force-bind-modal .field-input-checkbox .input-group:focus-within {
  color: #5c6873;
  border-color: #8ad4ee;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
  border-radius: 0.25rem !important;
}

.header-logo-wrapper {
  display: inline-block;
}
</style>
<style scoped lang="scss">
.bg-header-auto {
  background-color: $var-color-header-auto-icon !important;
}

.bg-primary-home {
  background-color: $var-color-home-icon !important;
}

.bg-primary-condo {
  background-color: $var-condo-header-icon !important;
}

.bg-primary-renters {
  background-color: $var-renter-section !important;
}

.bg-primary-bundle {
  background-color: $var-color-home-auto-bundle !important;
}
.breakdown-modal-top.dark-bg {
  background-color: $var-color-home-auto-bundle !important;
}

.rc2-car-logo {
  margin-left: 1.200rem;
  margin-top: 0.550rem;
}

.fa-icon-size {
  font-size: 1.625rem;
}

.col-primary {
  color: #003366;
}

.no-decor:hover {
  text-decoration: none;
}

#header-logo-buttons {
  height: auto !important;
}

#header-logo-buttons.auto,
#header-logo-buttons.auto .header-logo-wrapper {
  background-color: $var-color-header-auto;
}

#header-logo-buttons.home,
#header-logo-buttons.home .header-logo-wrapper {
  background-color: $var-color-home;
}

#header-logo-buttons.condo,
#header-logo-buttons.condo .header-logo-wrapper {
  background-color: $var-color-condo;
}

#header-logo-buttons.renters,
#header-logo-buttons.renters .header-logo-wrapper {
  background-color: $var-color-renter;
}

#header-logo-buttons.auto.bundleflow,
#header-logo-buttons.auto.bundleflow .header-logo-wrapper,
#header-logo-buttons.home.bundleflow,
#header-logo-buttons.home.bundleflow .header-logo-wrapper {
  background-color: $var-color-home-auto-bundle;
}

#header-logo-buttons .row.mx-0 {
  height: 100%;
}

#header-logo-buttons .menu-links {
  max-height: 48px;
}

#header-logo-buttons .icon-row {
  align-items: center;
  padding: 0.375rem 0;
}

#header-logo-buttons .navItem {
  display: block;
  padding: 0 1.25rem;
  font-size: 0.75rem;
  fill: currentcolor;
}

#header-logo-buttons.auto .navItem {
  color: $var-color-header-auto-icon;
}

#header-logo-buttons.home .navItem {
  color: $var-color-home-icon;
}

#header-logo-buttons.condo .navItem {
  color: $var-condo-header-icon;
}

#header-logo-buttons.renters .navItem {
  color: $var-renter-section;
}

#header-logo-buttons.home.bundleflow .navItem,
#header-logo-buttons.auto.bundleflow .navItem {
  color: $var-color-home-auto-bundle-icon;
}

#header-logo-buttons .navItem.inactive {
  color: #EEE;
  fill: currentcolor;
}

#header-logo-buttons a:hover {
  text-decoration: none !important;
}

#qsLogo {
  padding: 0.375rem 0;
}

#qsLogo img {
  width: auto;
  max-width: 200px;
  height: 36px;
}

.border-left-auto {
  border-left: 1px solid #fff !important;
  height: 26px;
  margin-left: 0.200rem;
  margin-right: 0.500rem;
}

#insuranceType {
  font-size: 1.75rem;
  color: #fff;

  .fa-home-auto-bundle,
  .fa-condo-auto-bundle,
  .fa-renter-auto-bundle {
    background-color: #FFFFFF;
  }
}

.logo-sep {
  background-color: #fff;
  height: 32px;
  width: 1px;
  margin: 2% 0;
}

.cursorPointer {
  cursor: pointer !important;
}

.cursorDefault {
  cursor: default;
}

.disabled,
.disabled svg {
  color: #EEE !important;
  fill: currentcolor;
}

.uniform-icon-size {
  font-size: 17px;
}

div.breakdown-modal-top h3 {
  font-size: 1rem;
  font-weight: bold;
}

.uniform-icon-breakdown {
  font-size: .7rem;
  float: right;
}

.breakdown-modal-header {
  display: inline-block;
}

.force-modal-subtext {
  color: #8a8a8a;
  font-size: .8rem;
}

.required-red {
  color: #FF4400;
}

.w-auto {
  width: auto !important;
}

label {
  display: inline-block;
  margin-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-weight: 600;
}

.btn-group.btn-group-toggle .btn {
  padding: 0.1875rem 1.5rem 0;
}

.btn-outline-light {
  color: #333333;
  background-color: transparent;
  background-image: none;
  border-color: #ced4da;
}

.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show>.btn-outline-light.dropdown-toggle {
  color: #FFFFFF;
  background-color: #003366;
  border-color: #003366;
}

.btn-group-toggle>.btn input[type=radio],
.btn-group-toggle>.btn input[type=checkbox],
.btn-group-toggle>.btn-group>.btn input[type=radio],
.btn-group-toggle>.btn-group>.btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

/***menu breakpoints***/
@media all and (max-width: 992px) {
  .navItem .btn-label {
    display: none;
  }
}

/** Product titles break per word - word-spacing should always be larger than parent width **/

.product-title-parent {
  color: white;
  margin-left: 15px;
  line-height: 15px;
  margin-top: 9px;

  span {
    display: block;
  }

  &.bundleflow {
    font-size: 12px;
    margin-top: 17px;

    span {
      display: inline;
    }
  }
}

.icon-row .initialForceBind:not(.clickableForceBind) {
  opacity: 0.7;
  cursor: not-allowed;
}

#header-logo-buttons.auto .initialForceBind:not(.clickableForceBind) {
  color: #959AA5;
}

#header-logo-buttons.home .initialForceBind:not(.clickableForceBind) {
  color: #97A5A5;
}

#header-logo-buttons.condo .initialForceBind:not(.clickableForceBind) {
  color: #A099A1;
}

#header-logo-buttons.renters .initialForceBind:not(.clickableForceBind) {
  color: #AB936C;
}

.icon-row .initialForceBind.clickableForceBind {
  opacity: 1;
  cursor: pointer;
}

.icon-row .initialForceBind.clickableForceBind:hover {
  opacity: 0.7;
}

.icon-row #export-toggle.initialExport:not(.clickableExport) {
  opacity: 0.7;
  cursor: not-allowed;
}

#header-logo-buttons.auto #export-toggle.initialExport:not(.clickableExport) {
  color: #959AA5;
}

#header-logo-buttons.home #export-toggle.initialExport:not(.clickableExport) {
  color: #97A5A5;
}

#header-logo-buttons.condo #export-toggle.initialExport:not(.clickableExport) {
  color: #A099A1;
}

#header-logo-buttons.renters #export-toggle.initialExport:not(.clickableExport) {
  color: #AB936C;
}

.icon-row #export-toggle.initialExport.clickableExport {
  opacity: 1;
  cursor: pointer;
}

.icon-row #export-toggle.initialExport.clickableExport:hover {
  opacity: 0.7;
}

.border-right-custom {
  border-right: 1px solid $var-color-header-auto !important;
}

#header-logo-buttons.home .border-right-custom {
  border-right: 1px solid $var-color-home-icon !important;
}

#header-logo-buttons.home .border-left-custom {
  border-left: 1px solid $var-color-home-icon !important;
}

#header-logo-buttons.renters .border-right-custom {
  border-right: 1px solid $var-renter-section !important;
}

#header-logo-buttons.renters .border-left-custom {
  border-left: 1px solid $var-renter-section !important;
}

#header-logo-buttons.condo .border-right-custom {
  border-right: 1px solid $var-condo-header-icon !important;
}

#header-logo-buttons.condo .border-left-custom {
  border-left: 1px solid $var-condo-header-icon !important;
}

.border-left-custom {
  border-left: 1px solid $var-color-header-auto !important;
}

.export-modal-container {
  text-align: center;

  .buttons {
    display: flex;
    justify-content: space-between;
  }

  P {
    color: #333;
    font-size: 16px;
  }

  #export-submit-button {
    background-color: #2E7B32;
    color: #fff;
    border-color: #2E7B32;
  }

  #export-submit-button:hover,
  #export-submit-button:focus {
    background-color: #fff;
    color: #2E7B32;
  }

  #export-cancel-button {
    background-color: #fff;
    color: #999;
    border-color: #999;
  }

  #export-cancel-button:hover,
  #export-cancel-button:focus {
    background-color: #999;
    color: #fff;
  }
}

.export-quote-success {
  position: fixed !important;
  top: 1rem;
  left: 35%;
  width: 30%;
  height: auto;
  z-index: 1100;
  color: #1A1A1A;
  background-color: #ECF8EB;
  border: 2px solid #2E7B32 !important;

  .epic-alert-icon {
    font-size: 25px;
    color: #2E7B32;
  }

  h4 {
    font-size: 20px;
  }
}

.export-quote-failure {
  position: fixed !important;
  top: 1rem;
  left: 35%;
  width: 30%;
  height: auto;
  z-index: 1100;
  color: #1A1A1A;
  background-color: #F5D9D9;
  border: 2px solid #BB0000 !important;

  .epic-alert-icon {
    font-size: 25px;
    color: #BB0000;
  }

  h4 {
    font-size: 20px;
  }
}
#header-logo-buttons.auto .fa-file-circle-plus{
  background-color: $var-color-header-auto-icon;
}
#header-logo-buttons.home .fa-file-circle-plus{
  background-color: $var-color-home-icon;
}
#header-logo-buttons.condo .fa-file-circle-plus{
  background-color: $var-condo-header-icon;
}
#header-logo-buttons.renters .fa-file-circle-plus{
  background-color: $var-renter-section;
}

.icon-row .initialAddProduct:not(.clickableAddProduct) {
  opacity: 0.7;
  cursor: not-allowed;
}

.icon-row .initialAddProduct.clickableAddProduct {
  opacity: 1;
  cursor: pointer;
}

.icon-row .initialAddProduct.clickableAddProduct:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/HeaderInterview.vue?5c63c076